import { Link } from "react-router-dom";
import { site } from "@/config/site";

export default function CtaBand() {
  return (
    <section aria-labelledby="cta-title" className="px-4 pb-14 pt-2 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-lg border border-background-200">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimal%20desk%20scene%20with%20a%20cup%20of%20tea%20and%20a%20laptop%20showing%20a%20news%20feed%2C%20soft%20morning%20light%2C%20editorial%20lifestyle%20photography%2C%20cream%20and%20terracotta%20tones&width=1600&height=600&seq=gu-cta-01&orientation=landscape"
            alt="诱惑吃瓜 每日瓜报订阅视觉"
            title="诱惑吃瓜 - 订阅每日瓜报"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/40" />
        </div>
        <div className="relative max-w-xl px-6 py-12 md:px-10 md:py-16">
          <h2 id="cta-title" className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
            怕错过今天的大瓜？让 {site.name} 帮你盯着
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200/90">
            我们会把当天最值得看的几条整理成一份简短瓜报，不刷屏、不标题党，只留真正有信息量的内容。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              订阅每日瓜报
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              先随便逛逛
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}